module.exports = __webpack_public_path__ + "img/b.0da63a98.jpg";